// englishDigits.js
// ✅ تحويل الأرقام العربية/الفارسية (٠١٢٣ / ۰۱۲۳) إلى أرقام إنكليزية (0123)
// تلقائياً أثناء الكتابة أو اللصق بكل حقول الإدخال بالنظام، حتى لو كان
// الكيبورد عربي. المتصفح ما يسمح بتغيير لغة الكيبورد نفسها، فنحوّل الرقم بدلها.

const DIGIT_MAP = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
  "٫": ".", // الفاصلة العشرية العربية
};

const NON_ENGLISH_DIGITS = /[٠-٩۰-۹٫]/g;
const HAS_NON_ENGLISH_DIGIT = /[٠-٩۰-۹٫]/;

const toEnglishDigits = (text) =>
  text.replace(NON_ENGLISH_DIGITS, (ch) => DIGIT_MAP[ch]);

const isTargetInput = (el) =>
  el instanceof HTMLInputElement &&
  !["password", "file", "checkbox", "radio"].includes(el.type);

// نحدّث القيمة بطريقة يحس بيها React (onChange) لحقول النص
const setNativeValue = (el, value) => {
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value").set;
  setter.call(el, value);
  el.dispatchEvent(new Event("input", { bubbles: true }));
};

export const enableEnglishDigits = () => {
  // الكتابة واللصق: نمنع الرقم العربي وندخل بداله الإنكليزي بنفس مكان المؤشر
  document.addEventListener(
    "beforeinput",
    (e) => {
      if (!isTargetInput(e.target) || !e.data || !HAS_NON_ENGLISH_DIGIT.test(e.data)) return;
      if (!e.cancelable) return; // كيبورد الموبايل أحياناً ما يقبل الإلغاء، يتعامل وياه input أدناه
      e.preventDefault();
      document.execCommand("insertText", false, toEnglishDigits(e.data));
    },
    true
  );

  // احتياط (كيبورد الموبايل/الإكمال التلقائي): نصحح أي رقم عربي وصل للحقل
  document.addEventListener(
    "input",
    (e) => {
      const el = e.target;
      if (!isTargetInput(el) || !HAS_NON_ENGLISH_DIGIT.test(el.value)) return;
      let caret = null;
      try {
        caret = el.selectionStart;
      } catch {
        // حقول number ما تدعم selectionStart
      }
      setNativeValue(el, toEnglishDigits(el.value));
      if (caret !== null) {
        try {
          el.setSelectionRange(caret, caret);
        } catch {
          // تجاهل
        }
      }
    },
    true
  );
};
